import { Typography,Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import priorities from "../../../config/priorities";
import sentiments from "../../../config/sentiments";
import languages from "../../../config/languages";
import { translatePost } from "../../../features/post";

import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import FunctionsIcon from '@mui/icons-material/Functions';
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import TranslateIcon from '@mui/icons-material/Translate';

function PostMetaElement({post, intent}){
    const project = useSelector(state => state.project.single);
    const tags = project?.tags;
    const dispatch = useDispatch();

    const metaIconStyle = {color:"#999999",fontSize:18,position:"relative",top:"4px",marginRight:"5px"};
    
    const engagementPercent = post.followers > 0
        ? ((post.engagement / post.followers) * 100).toFixed(2)
        : null;

    const roundedEngagement = typeof post.engagement === "number" ? Math.ceil(post.engagement) : post.engagement;

    return <>
    <Typography variant="body2">

    {
        roundedEngagement !== 0 && (
        <>
        <Tooltip title={engagementPercent !== null ? `Interactions/Followers ${engagementPercent}%` : ''} arrow disableInteractive>
            <span style={{display: "inline-flex", alignItems: "center", gap: "4px"}}>
                <FunctionsIcon alt="Engagement" title="Engagement" style={metaIconStyle}/>
                <b style={{fontSize: "14px",position:"relative", top:"4px", cursor:"default"}}>{roundedEngagement ?? "--"} {roundedEngagement === 1 ? 'interaction' : 'interactions'} {post.platform === 'tw' && <span style={{fontSize: "12px", color: "#666666"}}> (computed)</span>}</b>
                
            </span>
        </Tooltip>
        <br/>
    </>
    )
    }

    {
        post.sentiment !== 'null' && intent !== 'preview' && <>
        <SentimentSatisfiedOutlinedIcon alt="Sentiment" title="Sentiment" style={metaIconStyle}/>
    <b>{sentiments[post.sentiment]}</b><br/>
    </>
    }
    
    {
    post.lang && <>
    <LanguageOutlinedIcon style={metaIconStyle}/>
    <b>{languages[post.lang]}</b>
    {post.lang!=="en" && <>
    &nbsp;<TranslateIcon onClick={() => {
        if(intent !== 'preview'){ //esegui traduzione di contenuto da post già in Elasticsearch
            dispatch(translatePost({
                uuid: post.uuid,
                projectId: project.id,
            }))
        } else { // traduci post in anteprima 
            dispatch(
                translatePost({
                    intent: 'preview',
                    uuid: post.uuid,
                    postData: {
                        title: post.title,
                        post_text: post.post_text,
                        lang: post.lang
                    }
                })
            )
        }
    }} style={{...metaIconStyle, color: "#666666", cursor: "pointer"}}/>
    </>}
    <br/>
    </>
    }

    {intent !== 'preview' && <>
    <PriorityHighOutlinedIcon style={metaIconStyle}/>
    <b>{priorities[post.priority]}</b><br/>
    </>}
    
    {
        post.geo_countrycode && <>
        <FmdGoodOutlinedIcon style={metaIconStyle}/>
        <b>{post.geo_name}</b>, {post.geo_countrycode.toUpperCase()}<br/>
        {/* <a rel="noreferrer" target="_blank" href={'https://www.openstreetmap.org/#map=12/'+post.location.lat+'/'+post.location.lon}>{post.geo_name}</a>, {post.geo_countrycode.toUpperCase()}<br/> */}
        </>
    }
    
{
    post.tags && post.tags.length > 0 && <>
    <SellOutlinedIcon style={metaIconStyle}/> <b>{post.tags && post.tags.length > 0 ? post.tags.map(tag => {
        return tags.find(t => t.id === parseInt(tag));
    }).filter(t => !!t).map(t => t.label).join(", ") : "--"}</b><br/>
    </>
}   
    </Typography>
    </>
}
export default PostMetaElement;